export default function Services() {
  const services = [
    {
      icon: 'fa-warehouse',
      title: '보관/입출고',
      description: '체계적인 재고관리 시스템으로 안전하고 효율적인 보관 서비스를 제공합니다.',
      features: ['상온/냉장/냉동 보관', '실시간 재고 관리', '자동화 입출고 시스템']
    },
    {
      icon: 'fa-boxes',
      title: '유통가공',
      description: '고객 맞춤형 상품 패키징 및 라벨링 서비스로 브랜드 가치를 높입니다.',
      features: ['상품 검수 및 분류', '맞춤형 패키징', '라벨링 및 태깅']
    },
    {
      icon: 'fa-truck-fast',
      title: '배송대행',
      description: '전국 네트워크를 통한 신속하고 정확한 배송 서비스를 제공합니다.',
      features: ['당일/익일 배송', '실시간 배송 추적', '특송/화물 배송']
    },
    {
      icon: 'fa-store',
      title: '풀필먼트',
      description: '온라인 쇼핑몰을 위한 주문부터 배송까지 통합 물류 서비스입니다.',
      features: ['쇼핑몰 연동', '자동 주문 처리', 'CS 지원']
    },
    {
      icon: 'fa-chart-line',
      title: 'WMS 시스템',
      description: '실시간 물류 데이터 분석으로 최적의 의사결정을 지원합니다.',
      features: ['실시간 재고 현황', '데이터 분석 리포트', 'API 연동 지원']
    },
    {
      icon: 'fa-handshake',
      title: '맞춤형 솔루션',
      description: '고객사의 특성에 맞는 차별화된 물류 서비스를 설계합니다.',
      features: ['업종별 맞춤 설계', '전문 컨설팅', '유연한 계약 조건']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-cyan-600 font-semibold mb-2 tracking-wider text-sm">SERVICES</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">물류 토탈 솔루션</h2>
          <p className="text-gray-600 text-lg">입고부터 배송까지, 모든 물류 프로세스를 한번에</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`fas ${service.icon} text-blue-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                    <i className="fas fa-check text-cyan-600 mt-1"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}